module.exports = __webpack_public_path__ + "img/customer-service.1017028e.png";